import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import styles from "./AddBattery.module.scss";
import Master from "../Master";
import { useHistory } from "react-router-dom";
import { getRequest } from "services/axiosBaseClient";
// import DateTimePicker from "react-datetime-picker";
import {
  getRequestInAssets as getRequestOnEnterprise,
  postRequestInAssets as postRequestOnEnterprise,
  putRequestOnEnterprise,
  postFormDataRequestOnEnterprise,
  putFormDataRequestOnEnterprise,
} from "services/axiosAssetsBaseClient";
import TextField from "@material-ui/core/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getRequestInFileDownload } from "services/axiosFileDownloadService";
import { getRequestInService } from "services/axiosServiceBaseClient";
import jwt_decode from "jwt-decode";
import moment, { utc } from "moment";
import notificationService from "services/notification.service";
import ReactTooltip from "react-tooltip";

var id = undefined;
var action = null;
var title = "Add Battery";
var view = undefined;
var onlyView = false;
var readOnlyField = false;
var enterpriseName = "";
var userEnterprise = "";
var utcTime;
var fileName = "";
var tempExt = "";
var trimeFileName = "";
var fileIndexValue = "";

const AddBatteryForm = (props) => {
  const initialFormValues = {
    imei: "",
    batterySerialNumber: "",
    type: "-1",
    makeId: "-1",
    modelId: -1,
    model: "",
    year: "-1",
    enterprise: "",
    uploadSpec: "",
    status: "",
    make: "",
    dateOfpurchase: "",
    specFileActive: true,
    specFilePathError: "",
    fileExt: "",
    originSiteId: null,
  };

  const [makeList, setMakeList] = useState([]);
  const [makeName, setMakeName] = useState("");
  const [modelYearList, setModelYearList] = useState([]);
  const [batterySerialNumList, setBatterySerialNumList] = useState([]);
  const [operatorList, setOperatorList] = useState([]);
  const [batteryTypeList, setBatteryTypeList] = useState([]);
  const [sitesListLastest, setSitesListLastest] = useState([]);
  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState("");
  const [choosenFileName, setChoosenFileName] = useState("No file Choosen");
  const [file, setFile] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [tempChoosenFileName, setTempChoosenFileName] =
    useState("No file Choosen");
  const [toggleRemoveBtn, setToggleRemoveBtn] = useState(true);

  const history = useHistory();
  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      var size = parseFloat(img.size / (1024 * 1024)).toFixed(2);
      if (size > 3) {
        notificationService.showNonBlacklistedError(
          "",
          "Please select image size less than 3 MB."
        );
        return false;
      }
      const fileExtension = img.name.split(".").at(-1);
      const allowedFileTypes = [
        "jpg",
        "png",
        "jpeg",
        "pdf",
        "PDF",
        "JPG",
        "JPEG",
        "PNG",
      ];
      //initialFormValues.uploadSpec = URL.createObjectURL(img);
      setTempChoosenFileName(img.name);
      setChoosenFileName(img.name);
      console.log("image", choosenFileName);
      setFile(img);
      if (!allowedFileTypes.includes(fileExtension)) {
        setFormValues({ ...formValues, specFileActive: false });
      } else {
        setFormValues({ ...formValues, specFileActive: true });
      }
    }
  };
  const getBatteryDataByID = async (id, enterprise) => {
    fileName = "";
    tempExt = "";
    trimeFileName = "";
    fileIndexValue = "";

    await getRequestOnEnterprise(
      `bss/battery/getbatteryById?id=${id}&enterprise=${enterprise}`
    )
      .then((res) => {
        if (res.data != null) {
          patchForm(Array.isArray(res.data) ? res.data[0] : res.data);

          var fileUploadNameArr = res.data[0].specFilePath.split("/");
          const arrCount = fileUploadNameArr.length;
          setFile(res.data[0].specFilePath);

          const findFileExtIndexHandle = (extIndex) => {
            if (extIndex === ".pdf")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".pdf"));
            if (extIndex === ".jpg")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".jpg"));
            if (extIndex === ".jpeg")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".jpeg"));
            if (extIndex === ".png")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".png"));
            if (extIndex === ".PDF")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".PDF"));
            if (extIndex === ".JPG")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".JPG"));
            if (extIndex === ".JPEG")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".JPEG"));
            if (extIndex === ".PNG")
              return (fileIndexValue =
                fileUploadNameArr[arrCount - 1].indexOf(".PNG"));
          };

          const trimeFileNameHandle = (extType) => {
            if (extType === ".pdf")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".pdf")),
                findFileExtIndexHandle(extType)
              );
            if (extType === ".jpg")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".jpg")),
                findFileExtIndexHandle(extType)
              );
            if (extType === ".jpeg")
              return (
                (trimeFileName =
                  fileUploadNameArr[arrCount - 1].split(".jpeg")),
                findFileExtIndexHandle(extType)
              );
            if (extType === ".png")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".png")),
                findFileExtIndexHandle(extType)
              );
            if (extType === ".pdf")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".pdf")),
                findFileExtIndexHandle(extType)
              );
            if (extType === ".PDF")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".PDF")),
                findFileExtIndexHandle(extType)
              );
            if (extType === ".JPG")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".JPG")),
                findFileExtIndexHandle(extType)
              );
            if (extType === ".JPEG")
              return (
                (trimeFileName =
                  fileUploadNameArr[arrCount - 1].split(".JPEG")),
                findFileExtIndexHandle(extType)
              );
            if (extType === ".PNG")
              return (
                (trimeFileName = fileUploadNameArr[arrCount - 1].split(".PNG")),
                findFileExtIndexHandle(extType)
              );
          };

          const result = () => {
            if (fileUploadNameArr[arrCount - 1].includes(".pdf"))
              return (tempExt = ".pdf"), trimeFileNameHandle(tempExt);
            if (fileUploadNameArr[arrCount - 1].includes(".jpg"))
              return (tempExt = ".jpg"), trimeFileNameHandle(tempExt);
            if (fileUploadNameArr[arrCount - 1].includes(".jpeg"))
              return (tempExt = ".jpeg"), trimeFileNameHandle(tempExt);
            if (fileUploadNameArr[arrCount - 1].includes(".png"))
              return (tempExt = ".png"), trimeFileNameHandle(tempExt);
            if (fileUploadNameArr[arrCount - 1].includes(".pdf"))
              return (tempExt = ".pdf"), trimeFileNameHandle(tempExt);
            if (fileUploadNameArr[arrCount - 1].includes(".PDF"))
              return (tempExt = ".PDF"), trimeFileNameHandle(tempExt);
            if (fileUploadNameArr[arrCount - 1].includes(".JPG"))
              return (tempExt = ".JPG"), trimeFileNameHandle(tempExt);
            if (fileUploadNameArr[arrCount - 1].includes(".JPEG"))
              return (tempExt = ".JPEG"), trimeFileNameHandle(tempExt);
            if (fileUploadNameArr[arrCount - 1].includes(".PNG"))
              return (tempExt = ".PNG"), trimeFileNameHandle(tempExt);
          };

          result();

          const shortFileName = trimeFileName && trimeFileName[0].slice(0, 10);
          const fileExt = fileUploadNameArr[arrCount - 1].slice(fileIndexValue);
          setChoosenFileName(
            shortFileName.length > 0
              ? shortFileName + fileExt
              : "No file Choosen"
          );
          // setChoosenFileName(shortFileName + fileExt);
          // const result = arr[arr.length - 1].includes(
          //   ".pdf" || ".jpg" || ".png" || ".pdf" || ".PDF" || ".JPG" || ".PNG"
          // );

          // const trimeFileName = arr[arr.length - 1].split(
          //   ".pdf" || ".jpg" || ".png" || ".pdf" || ".PDF" || ".JPG" || ".PNG"
          // );

          // const testingF = arr[arr.length - 1].indexOf(
          //   ".pdf" || ".jpg" || ".png" || ".pdf" || ".PDF" || ".JPG" || ".PNG"
          // );

          // const fileExt = arr[arr.length - 1].slice(testingF);
          // setChoosenFileName(result ? trimeFileName[0] + fileExt : arr[arrCount - 1]);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  };

  const uniqueIds = [];
  const unique = modelYearList.filter((element) => {
    const isDuplicate = uniqueIds.includes(element?.year);

    if (!isDuplicate) {
      uniqueIds.push(element?.year);

      return true;
    }

    return false;
  });

  const patchForm = (data) => {
    data.fileLocation = data.fileLocation === "" ? null : data.fileLocation;
    data.specFilePath = data.specFilePath === null ? "" : data.specFilePath;
    const tempDate = data.warrantyStartDate;
    const formatingDate = moment(tempDate).format("ddd MMM DD YYYY hh:mm:ss a");
    const srtingDate = new Date(formatingDate).toISOString();
    fileName = data?.specFilePath;
    setTempChoosenFileName(data?.specFilePath);
    setFormValues({
      originSiteId: data.originSiteId,
      batterySerialNumber: data.batterySerialNumber,
      type: data.type,
      makeId: data.makeId,
      modelId: data.modelId,
      model: data.model,
      year: data.year,
      enterprise: data.enterprise,
      id: data.id,
      status: data.status,
      imei: data?.imei ? data?.imei : "",
      // batteryStatus: "DECOMMISSION",
      dateOfpurchase: formatingDate ? new Date(srtingDate) : null,
      enterprise: data.enterprise,
      specFilePath: data?.specFilePath,
      fileExt: data?.specFilePath.substring(
        data?.specFilePath.indexOf(".") + 1
      ),
    });
    getModels(data.makeId, data.modelId);
  };

  const removeUploadFile = (e) => {
    e.stopPropagation();
    fileName = "";
    setTempChoosenFileName(() => "No file Choosen");
    setFormValues({
      ...formValues,
      ["specFilePath"]: "",
      ["fileExt"]: "",
    });
  };

  id = props.match.params.id;
  view = props.match.params.view;

  const routeChange = () => {
    history.push({
      pathname: "/Assets",
      state: { table: 3, compomentRenderType: "view" },
    });
  };

  const getBatterySerialNumber = useCallback(async (string) => {
    await getRequestOnEnterprise("make/getAll?type=BATTERY")
      .then((res) => {
        if (res.data != null) {
          setBatterySerialNumList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getBatteryType = useCallback(async (string) => {
    await getRequestOnEnterprise("bss/battery/getBatteryTypes")
      .then((res) => {
        if (res.data != null) {
          setBatteryTypeList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getMakes = useCallback(async (string) => {
    await getRequestOnEnterprise("make/getAll?type=BATTERY")
      .then((res) => {
        if (res.data != null) {
          setMakeList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getModels = useCallback(async (id) => {
    await getRequestOnEnterprise(
      "model/getAll?enterprise=" +
        formValues.enterprise +
        "&makeId=" +
        id +
        "&type=BATTERY"
    )
      .then((res) => {
        if (res && res.data) {
          setModelYearList(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getSite = useCallback(async () => {
    await getRequestOnEnterprise(`bss/siteInfo`)
      .then((res) => {
        if (res?.data?.count >= 1) {
          setSitesListLastest(res.data.sites);
          //props.assetCount(()=>res.data.count);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getOperators = useCallback(async () => {
    await getRequestInService("bss/svc/enterpriseName/getall")
      .then((res) => {
        if (res && res.data && res.data.length >= 1) {
          setOperatorList(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    if (name === "makeId") {
      getModels(value);
      formValues.makeId = value;
      setFormValues({ ...formValues, modelId: "" });

      makeList.find((data) => {
        if (data.id == value) {
          formValues.make = data.name;
          setMakeName(data.name);
        }
      });
    }

    if (name === "modelId") {
      setFormValues({
        ...formValues,
        model: "",
        modelId: Number(value),
      });

      modelYearList.find((data) => {
        if (data.id == value) {
          formValues.modelId = data.id;
          setFormValues({
            ...formValues,
            //  model: data.name,
            //  modelId: Number(data.id)
            model: data.name,
            modelId: Number(data.id),
            makeId: data.makeId,
            make: makeName,
          });
        }
      });
    }
    if (name === "originSiteId") {
      var st = sitesListLastest.find((x) => {
        return value == x.siteId;
      });

      setFormValues({
        ...formValues,
        originSiteId: st?.siteId ? st.siteId : null,
      });
    }
  };
  const handleDateChange = (e) => {
    if (e) {
      setFormValues({ ...formValues, dateOfpurchase: new Date(e) });
    } else {
      setFormValues({ ...formValues, dateOfpurchase: "" });
    }
  };

  const downloadFile = useCallback(async (enterprise, filePath) => {
    if (!onlyView) {
      return;
    }
    await getRequestInFileDownload(
      `downloadFile/${formValues.enterprise}?fileName=${encodeURIComponent(
        formValues.specFilePath
      )}`
    ).then((res) => {
      if (res) {
        downloadPDF(res);
      }
    });
  });

  function downloadPDF(pdf) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = formValues.batterySerialNumber + "." + formValues?.fileExt;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    let result = validate(formValues, file);

    if (Object.values(result).every((x) => x === "")) {
      setButtonDisabled(true);
      if (action === "Update") {
        try {
          utcTime =
            moment(formValues.dateOfpurchase).format(
              "YYYY-MM-DDTHH:mm:ss.SSS"
            ) + "Z";
          var formVal = JSON.parse(JSON.stringify(formValues));
          formVal = {
            ...formVal,
            warrantyStartDate: utcTime,
            type: formVal.type.replace(/ /g, ""),
          };
          delete formVal["dateOfpurchase"];
          const formData = new FormData();
          formData.append("file", file);
          formData.append("data", JSON.stringify(formVal));
          formData.append("enterprise", enterpriseName); //varun set the value and remove comment
          putFormDataRequestOnEnterprise("bss/battery/updateBattery", formData)
            .then((res) => {
              if (res && res?.data) {
                history.push({
                  pathname: "/Assets",
                  state: { table: 3, compomentRenderType: "view" },
                });
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.data?.message
                );
                setButtonDisabled(false);
              }
            })
            .catch((error) => {
              console.log(error, "ERROR");
              setButtonDisabled(false);
              notificationService.showNonBlacklistedError(
                error?.config?.url,
                error?.response?.data?.message
              );
              return error;
            });
        } catch (error) {
          setButtonDisabled(false);
          notificationService.showNonBlacklistedError(
            error?.config?.url,
            error?.message
          );
          console.log(error);
        }
      } else {
        try {
          const test = formValues.dateOfpurchase;
          utcTime =
            moment(formValues.dateOfpurchase).format(
              "YYYY-MM-DDTHH:mm:ss.SSS"
            ) + "Z";
          var formVal = JSON.parse(JSON.stringify(formValues));
          formVal = {
            ...formVal,
            warrantyStartDate: utcTime,
            dateOfpurchase: utcTime,
          };
          delete formVal["dateOfpurchase"];
          formVal = {
            ...formVal,
            dateOfpurchase: utcTime,
          };
          const formData = new FormData();
          formData.append("file", file);
          formData.append("data", JSON.stringify(formVal));

          postFormDataRequestOnEnterprise("bss/battery/addBattery", formData)
            .then((res) => {
              if (res && res?.data) {
                history.push({
                  pathname: "/Assets",
                  state: { table: 3 },
                });
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.data?.message
                );
                setButtonDisabled(false);
              }
            })
            .catch((error) => {
              setButtonDisabled(false);
              notificationService.showNonBlacklistedError(
                error?.config?.url,
                error?.response?.data?.message
              );
              return error;
            });
        } catch (error) {
          setButtonDisabled(false);
          notificationService.showNonBlacklistedError(
            error?.config?.url,
            error?.message
          );
          reset();
          console.log(error);
        }
      }
    }
  };

  const validate = (formValues) => {
    const errors = {};

    if (formValues.specFileActive === false) {
      errors.specFilePathError =
        "jpg, jpeg, png, pdf are the only allowed file type";
    } else {
      errors.specFilePathError = "";
    }

    if (!formValues.batterySerialNumber) {
      errors.batterySerialNumber = "Battery Serial Number is required!";
    } else if (!/^[ A-Za-z0-9-_.&']*$/i.test(formValues.batterySerialNumber)) {
      errors.batterySerialNumber =
        "-_&. are the only allowed special characters!";
    } else if (formValues.batterySerialNumber.trim() === "") {
      errors.batterySerialNumber = "This is not valid Battery Serial Number";
    } else {
      errors.batterySerialNumber = "";
    }

    if (formValues.type === "-1") {
      errors.type = "Battery Type is required!";
    } else {
      errors.type = "";
    }

    if (!formValues.makeId || formValues.makeId === "-1") {
      errors.makeId = "Make is required!";
    } else {
      errors.makeId = "";
    }

    if (!formValues.modelId || formValues.modelId === -1) {
      errors.modelId = "Model is required!";
    } else {
      errors.modelId = "";
    }

    if (!formValues.year || formValues.year === "-1") {
      errors.year = "Year is required!";
    } else {
      errors.year = "";
    }

    if (!formValues.enterprise) {
      errors.enterprise = "Enterprise name is required!";
    } else {
      errors.enterprise = "";
    }

    // if (!formValues.originSiteId || formValues.originSiteId === "-1") {
    //   errors.originSiteId = "Site Name is required!";
    // } else {
    //   errors.originSiteId = "";
    // }

    if (!formValues.status || formValues.status === "-1") {
      errors.status = "Battery status is required!";
    } else {
      errors.status = "";
    }
    if (!formValues.dateOfpurchase || formValues.dateOfpurchase === "-1") {
      errors.dateOfpurchase = "Date of purchase is required!";
    } else {
      errors.enterpriseName = "";
    }

    setFormErrors(errors);
    return errors;
  };

  const reset = () => {
    setFormValues(initialFormValues);
  };

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("token"));
    const { accessToken } = token;
    const decodedToken = jwt_decode(accessToken);
    userEnterprise = decodedToken.group[0];
    formValues.enterprise = userEnterprise;
    getSite();
    enterpriseName = userEnterprise;
    getBatterySerialNumber();
    getBatteryType();
    getMakes();
    // getModels();
    // getOperators();
    if (id !== undefined && view == undefined) {
      action = "Update";
      title = "Update Battery";
      readOnlyField = true;
      onlyView = false;
      getBatteryDataByID(id, enterpriseName);
    } else if (id !== undefined && view !== undefined) {
      action = "view";
      title = "View Battery";
      onlyView = true;
      getBatteryDataByID(id, enterpriseName);
    } else {
      onlyView = false;
      title = "Add Battery";
      action = "Submit";
    }
  }, []);

  return (
    <>
      <h2
        id="AddBattery_Heading"
        className={cn(styles.medium_title, styles.medium_title_layout)}
      >
        {"Battery"}
      </h2>

      <div
        id="AddBattery_Form_layout"
        className={cn(styles.group, styles.group_layout)}
      >
        <form id="AddBattery_Form">
          <div
            id="AddBattery_Form_block"
            className={cn(styles.flex3, styles.flex3_layout)}
          >
            <h3
              id="AddBattery_Form_title"
              className={cn(styles.subtitle, styles.subtitle_layout)}
            >
              {title}
            </h3>
            <hr className={cn(styles.line, styles.line_layout)} />

            <div
              id="AddBattery_Form_row1"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddBattery_BatterySerialNumber_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddBattery_BatterySerialNumber"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddBattery_BatterySerialNumber_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Battery Serial Number*"}
                  </div>
                  <input
                    id="AddBattery_BatterySerialNumber_input"
                    name="batterySerialNumber"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.batterySerialNumber}
                    onChange={handleChange}
                    maxLength="50"
                    disabled={onlyView}
                  />
                </div>
                <p>{formErrors.batterySerialNumber}</p>
              </div>

              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddBattery_BatteryType_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddBattery_BatteryType"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddBattery_BatteryType_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Battery Type*"}
                  </div>

                  <select
                    id="AddBattery_BatteryType_select"
                    name="type"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.type.replace(/ /g, "")}
                    onChange={handleChange}
                    disabled={onlyView}
                  >
                    <option value="-1">Select Battery Type</option>
                    {batteryTypeList.map((val) => {
                      return (
                        <option value={val.replace(/ /g, "")}>{val}</option>
                      );
                    })}
                  </select>
                </div>
                <p>{formErrors.type}</p>
              </div>
            </div>

            <div
              id="AddBattery_Form_row2"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div id="AddBattery_Make_block" className={cn(styles.flex2_item)}>
                <div
                  id="AddBattery_Make"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddBattery_Make_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Make*"}
                  </div>
                  <select
                    id="AddBattery_Make_select"
                    name="makeId"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.makeId}
                    onChange={handleChange}
                    disabled={onlyView}
                  >
                    <option value="-1">Select Make</option>
                    {makeList.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <p>{formErrors.makeId}</p>
              </div>

              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddBattery_Model_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddBattery_Model"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddBattery_Model_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Model*"}
                  </div>
                  <select
                    id="AddBattery_Model_select"
                    name="modelId"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.modelId}
                    onChange={handleChange}
                    disabled={onlyView}
                  >
                    <option value={-1}>Select Model</option>
                    {modelYearList.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <p>{formErrors.modelId}</p>
              </div>
            </div>

            <div
              id="AddBattery_Form_row3"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div id="AddBattery_Year_block" className={cn(styles.flex2_item)}>
                <div
                  id="AddBattery_Year"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddBattery_Year_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Year*"}
                  </div>
                  <select
                    id="AddBattery_Year_select"
                    name="year"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.year}
                    onChange={handleChange}
                    disabled={onlyView}
                  >
                    <option value="-1">Select Year</option>
                    {unique.map((calendar) => {
                      return (
                        <option value={calendar.year}>{calendar.year}</option>
                      );
                    })}
                  </select>
                </div>
                <p>{formErrors.year}</p>
              </div>

              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddBattery_uploadDownload_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddBattery_uploadDownload_file"
                  className={cn(
                    styles.block3,
                    styles.block3_layout,
                    styles.displayBlock,
                    styles.newBlock,
                    styles.upload_Fild
                  )}
                  onClick={downloadFile}
                >
                  <input
                    type="file"
                    name="fileLocation"
                    id="img"
                    accept="image/png, image/jpeg, application/pdf"
                    onChange={onImageChange}
                    style={{ display: "none", width: "40%" }}
                    disabled={onlyView}
                    onClick={(event) => {
                      const { target = {} } = event || {};
                      target.value = "";
                    }}
                  />
                  <div
                    data-for="main"
                    data-tip={tempChoosenFileName}
                    style={
                      choosenFileName == "No file Choosen" && onlyView
                        ? {
                            height: "30px",
                            width: "50%",
                            float: "left",
                            display: "flex",
                            alignItems: "center",
                          }
                        : {
                            height: "30px",
                            width: "50%",
                            float: "left",
                            display: "flex",
                            alignItems: "center",
                          }
                    }
                  >
                    {choosenFileName === "No file Choosen" && onlyView
                      ? "No file Choosen"
                      : choosenFileName}
                  </div>

                  <div
                    id="AddBattery_uploadDownload_button"
                    className={cn(styles.upload_right_side_btn_container)}
                  >
                    <label
                      className={cn(styles.remove_Fild_btn)}
                      style={{
                        display:
                          toggleRemoveBtn === false
                            ? "none"
                            : choosenFileName === "No file Choosen"
                            ? "none"
                            : choosenFileName === "" && onlyView
                            ? "none"
                            : !onlyView &&
                              choosenFileName.length !== "No file Choosen"
                            ? "flex"
                            : "none",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "28px",
                        width: "33px",
                        borderRadius: "5px",
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        setChoosenFileName(() => "No file Choosen");
                        removeUploadFile(e);
                        setToggleRemoveBtn(false);
                      }}
                    >
                      X
                    </label>
                    <label
                      for="img"
                      // className={cn(styles.block7, styles.label_block)}
                      style={{
                        display:
                          onlyView && choosenFileName !== "No file Choosen"
                            ? "flex"
                            : !onlyView
                            ? "flex"
                            : "none",
                        marginRight: "20px",
                        border: "none",
                        backgroundColor: "#23297a",
                        color: "white",
                        height: "28px",
                        padding: "6px 15px",
                        width: "120px",
                        float: "right",
                        textAlign: "center",
                        borderRadius: "5px",
                        cursor: "pointer",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onClick={(e) => {
                        setToggleRemoveBtn(true);
                      }}
                    >
                      {onlyView && choosenFileName !== "No file Choosen"
                        ? "Download"
                        : !onlyView
                        ? "Upload File"
                        : ""}
                    </label>
                  </div>
                </div>
                <p>{formErrors.specFilePathError}</p>
              </div>
              <ReactTooltip id="main" type="dark" />
            </div>

            <div
              id="AddBattery_Form_row4"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddBattery_EnterpriseName_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddBattery_EnterpriseName"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddBattery_EnterpriseName_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Enterprise Name*"}
                  </div>

                  <input
                    id="AddBattery_EnterpriseName_input"
                    name="enterprise"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.enterprise}
                    onChange={handleChange}
                    disabled
                  />

                  {/* <select
                    name="enterprise"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.enterprise}
                    onChange={handleChange}
                    disabled={onlyView}
                  >
                    <option value="-1">Select Enterprise Name</option>
                    {operatorList.map((obj) => {
                      return (
                        <option value={obj.enterpriseName}>
                          {obj.enterpriseName}
                        </option>
                      );
                    })}
                  </select> */}
                </div>
                <p>{formErrors.enterpriseName}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div id="AddBattery_Site_block" className={cn(styles.flex2_item)}>
                <div
                  id="AddBattery_Site"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddBattery_Site_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Site"}
                  </div>

                  <select
                    id="AddBattery_Site_select"
                    name="originSiteId"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.originSiteId}
                    onChange={handleChange}
                    disabled={onlyView}
                  >
                    <option value="-1">Select Site</option>
                    {sitesListLastest.map((obj) => {
                      return <option value={obj.siteId}>{obj.siteName}</option>;
                    })}
                  </select>
                </div>
                <p>{formErrors.originSiteId}</p>
              </div>
            </div>
            <div
              id="AddBattery_Form_row5"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddBattery_DateOfPurchase_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddBattery_DateOfPurchase"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddBattery_DateOfPurchase_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Date of Purchase*"}
                  </div>

                  {/* <hr className={cn(styles.line1, styles.line1_layout)} />  */}
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      name="DateOfPurchase"
                      views={["year", "month", "day"]}
                      inputFormat="DD-MM-YYYY"
                      maxDate={new Date()}
                      value={formValues.dateOfpurchase}
                      onChange={(date) => handleDateChange(date)}
                      renderInput={(params) => <TextField {...params} />}
                      InputProps={{
                        disableUnderline: true,
                        style: { borderBottom: "2px solid rgb(175,180,197)" },
                      }}
                      disabled={onlyView}
                    />
                  </LocalizationProvider>
                </div>
                <p>{formErrors.dateOfpurchase}</p>
              </div>

              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddBattery_BatteryIMEI_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddBattery_BatteryIMEI"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddBattery_BatteryIMEI_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Battery IMEI"}
                  </div>
                  <input
                    id="AddBattery_BatteryIMEI_input"
                    name="imei"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.imei}
                    onChange={handleChange}
                    disabled={onlyView}
                    maxLength={40}
                  />
                </div>
                <p>{formErrors.imei}</p>
              </div>
            </div>
            <div
              id="AddBattery_Form_row6"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddBattery_BatteryStatus_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddBattery_BatteryStatus"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddBattery_BatteryStatus_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Battery Status*"}
                  </div>

                  <select
                    id="AddBattery_BatteryStatus_select"
                    name="status"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.status}
                    onChange={handleChange}
                    disabled={onlyView}
                  >
                    <option value="-1">Select Battery Status</option>
                    <option value="COMMISSIONED">Commissioned</option>
                    <option value="DECOMMISSIONED">Decommissioned</option>
                    <option value="PRECOMMISSIONED">PreCommissioned</option>
                    {/* {operatorList.map((obj) => {
                      return (
                        <option value={obj.username}>{obj.username}</option>
                      );
                    })} */}
                  </select>
                </div>
                <p>{formErrors.status}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div className={cn(styles.flex2_item)}></div>
            </div>

            {/* <div className={cn(styles.flex2_spacer)} />
              <div className={cn(styles.flex2_item)}></div> */}

            <div
              id="AddBattery_Button_container"
              className={cn(styles.flex9, styles.flex9_layout)}
            >
              <div
                id="AddBattery_Button_container1"
                className={cn(styles.flex9_item)}
                onClick={routeChange}
              >
                <div
                  id="AddBattery_Button_block"
                  onClick={reset}
                  className={cn(styles.block7, styles.block7_layout)}
                >
                  <h5
                    id="AddBattery_BackButton_title"
                    className={cn(
                      styles.highlights1,
                      styles.highlights1_layout
                    )}
                  >
                    {onlyView ? "Back" : "Cancel"}
                  </h5>
                </div>
              </div>

              {!onlyView ? (
                <>
                  <div className={cn(styles.flex9_spacer)} />
                  {/* <div className={cn(styles.flex9_item)}> */}
                  <div
                    style={{
                      width: "150px",
                      position: "relative",
                      bottom: "22px",
                    }}
                  >
                    <button
                      id="AddBattery_SubmitButton"
                      className={cn(
                        styles.block9,
                        styles.block9_layout,
                        styles.submit_layout
                      )}
                      onClick={handleSubmit}
                      style={{
                        backgroundColor: "#315CBB",
                      }}
                      disabled={buttonDisabled}
                    >
                      <h5
                        id="AddBattery_submitButton_title"
                        className={cn(
                          styles.highlights2,
                          styles.highlights2_layout
                        )}
                      >
                        {action}
                      </h5>
                    </button>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default function AddBattery(props) {
  return (
    <>
      <Master opts={props} screen={AddBatteryForm} showStatus={false} />
    </>
  );
}

AddBattery.inStorybook = true;
